import template from './ad-type.jade';
import adTypeCtrl from './ad-type.controller';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      dealType: '=',
      propertyType: '=',
      rentDuration: '=',
      objectType: '=',
      category: '=',
      ad: '=',
      objectSubType: '@',
    },
    controller: adTypeCtrl,
    controllerAs: 'adTypeCtrl',
    replace: true,
  };
};
